<template>
  <el-dialog
    :close-on-press-escape="false"
    custom-class="layout-dialog"
    title="各種データダウンロード"
    top="5vh"
    width="580px"
    :visible="dialogVisible2"
    append-to-body
    class="el_dialog"
    @close="close"
  >
    <div
      v-for="(item, index) in list"
      :key="index"
      class="flex_colum"
      :class="index + 1 == list.length ? '' : 'dialog_item'"
    >
      <div v-if="item.title" class="text_84">{{ item.title }}</div>
      <div class="flex_center_align">
        <vab-button :btn-list="item.buttonList" />
      </div>
    </div>
    <div slot="footer" class="dialog-footer flex_end mg12">
      <div class="flex_start flex_center_align">
        <vab-button :btn-list="btnList" />
      </div>
    </div>
  </el-dialog>
</template>

<script>
  export default {
    name: 'PopupChildren',
    props: {
      visible2: {
        type: Boolean,
        default: false,
      },
      list: {
        type: Array,
        default: null,
      },
    },
    data() {
      return {
        dialogVisible2: false,
        formDay: {},
        rulesDay: {},
        open: '2',
        btnList: [
          {
            name: '閉じる',
            icon: 'answer',
            type: 'button',
            hidden: false,
            click: () => {
              this.close()
            },
          },
        ],
        value: '',
      }
    },
    watch: {
      visible2: function (val) {
        this.dialogVisible2 = val
      },
    },
    methods: {
      close() {
        this.dialogVisible2 = false
        this.$emit('update:visibleChildren', false)
      },
    },
  }
</script>

<style lang="scss" scoped>
  .text_84 {
    font-family: 'Noto Sans JP';
    font-style: normal;
    font-weight: 400;
    font-size: 13px;
    line-height: 150%;
    /* identical to box height, or 20px */
    color: #848484;
    margin-bottom: 8px;
  }

  .dialog_item {
    border-bottom: 1px dashed #eee;
    padding-bottom: 16px;
    margin-bottom: 16px;
  }
  .el_dialog {
    ::v-deep .el-dialog__title {
      font-family: 'Noto Sans JP';
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 150%;
      color: #003350;
    }
    ::v-deep .el-dialog__header {
      padding: 12px;
    }
    ::v-deep .el-dialog__body {
      padding: 24px;
    }
    ::v-deep .el-dialog__headerbtn {
      top: 12px;
      font-size: 24px;
    }

    .flex_center_align {
      ::v-deep.btn_box {
        margin-left: 0;
        margin-right: 8px;
      }
    }
  }
</style>
